import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ClientsPage } from './clients.page';
import { ClientsDesktopPage } from './desktop/clients.desktop.page';
import { ClientsMobilePage } from './mobile/clients.mobile.page';
import { TranslationModule } from '@app/app-translation.module';
import { HeaderComponentModule } from '@shared/gui/structural-components/header-component/header.component.module';
import { SegmentDesktopModule } from '@beego/ngx-segment';
import { PipesModule } from '@shared-pipes/pipes.module';
import { DirectivesModule } from '@shared-directives/directives.module';
import { TableDesktopModule } from '@beego/ngx-table';
import { AppModule } from '@app/app.module';
import { StateManager } from '@shared-managers/state.manager';
import { TranslateService } from '@ngx-translate/core';
import { CreateClientComponentModule } from '@internal-components/client-components/create-client-component/create-client.component.module';
import { MobileBlockerComponentModule } from '@internal/gui/structural-components/mobile-blocker-component/mobile-blocker-component.module';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		IonicModule,
		RouterModule.forChild([
			{
				path: '',
				component: ClientsPage,
			},
		]),
		TranslationModule,
		HeaderComponentModule,
		SegmentDesktopModule,
		TableDesktopModule.forRoot(AppModule.injector.get(StateManager), AppModule.injector.get(TranslateService)),
		PipesModule,
		DirectivesModule,
		CreateClientComponentModule,
		MobileBlockerComponentModule,
	],
	declarations: [ClientsDesktopPage, ClientsMobilePage, ClientsPage],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ClientsPageModule {}
